import { render } from "./DeckList.vue?vue&type=template&id=636f832a&scoped=true"
import script from "./DeckList.vue?vue&type=script&lang=js"
export * from "./DeckList.vue?vue&type=script&lang=js"

import "./DeckList.vue?vue&type=style&index=0&id=636f832a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/marvel-lcg-randomizer/marvel-lcg-randomizer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-636f832a"]])

export default __exports__